import { Box, styled } from '@mui/material';

export const EmployeeSearchContainer = styled(Box)(({ theme }) => ({
  width: '15%',
  padding: `${theme.spacing(3)} ${theme.spacing(2)} 0 ${theme.spacing(2)}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
